import post from './post.js';
import get from './get.js';

export default {
	get_list: ({ session }) => get('organizations/list', { session }),
	create: ({ session, data }) => post('organizations/create', { session, data }),
	delete: ({ session, uid }) => post('organizations/delete', { session, uid }),
	get_by_id: ({ session, uid }) => get('organizations/get', { session, uid }),
	update: ({ session, uid, data }) => post('organizations/update', { session, uid, data }),
};
